import React from 'react'
import {
    Dimensions
} from 'react-native'
import { useHeaderHeight } from '@react-navigation/stack'
import { Text, Button, Icon, Box, VStack, HStack, Modal, ScrollView } from 'native-base'
import moment from 'moment'
import { Ionicons } from '@expo/vector-icons'
import HTML from 'react-native-render-html'

export default function UserCouponDetail(props) {
    const headerHeight = useHeaderHeight();
    const { t, userCoupon, buttonDisabled, isSuccessModalVisible } = props
    const { coupon, status } = userCoupon
    const disabled = buttonDisabled || status == 'INACTIVE'
    console.log(coupon)
    return (
        <Box h={Dimensions.get('window').height - headerHeight} bgColor={"white"} w='100%' p={2}>
            <ScrollView flex={1} showsVerticalScrollIndicator={false}>
                <VStack py={4}>
                    <Text isTruncated fontSize={'2xl'} color={'primary.100'} py={4}>{coupon.name}</Text>
                    <HStack alignItems={'center'}>
                        <Icon name={'md-time'} as={Ionicons} size={'xs'} />
                        <Text isTruncated fontSize={'xs'} px={2} color={'primary.100'}>{`${moment(coupon.endDate).format('YYYY-MM-DD hh:mm')} ${t('expired')}`}</Text>
                    </HStack>
                </VStack>
                <VStack py={4}>
                    <Text isTruncated fontSize={'2xl'} >{t('couponIntro')}</Text>
                    <HTML imagesMaxWidth={Dimensions.get('window').width - 40} allowedStyles={[]} source={{ html: coupon.detail }} />
                </VStack>
                <VStack py={4}>
                    <Text isTruncated fontSize={'2xl'}>{t('userCouponDetail')}</Text>
                    <Text isTruncated fontSize={'xs'}>{t('minPriceRequired', { minPriceRequired: coupon.minPriceRequired })}</Text>
                    <Text isTruncated fontSize={'xs'}>{t('maxPurchase', { maxPurchase: coupon.maxPurchase })}</Text>
                    <Text isTruncated fontSize={'xs'}>{t('discount', { discount: coupon.discount })}</Text>
                </VStack>
                <VStack py={4}>
                    <Text isTruncated fontSize={'2xl'}>{t('TnC')}</Text>
                    <HTML imagesMaxWidth={Dimensions.get('window').width - 40} allowedStyles={[]} source={{ html: coupon.terms }} />
                </VStack>
            </ScrollView>
            <VStack>
                <Button disabled={disabled || status == 'INACTIVE'} bgColor={disabled ? 'gray.600' : 'primary.100'} onPress={() => props.onUseCouponPress()}>
                    <Text isTruncated px={2} py={1} color={'white'}>{status == 'INACTIVE' ? t('usedAlready') : t('useCoupon')}</Text>
                </Button>
            </VStack>
            <Modal isOpen={isSuccessModalVisible} onClose={() => props.onSuccessModalClose()}>
                <Modal.Content maxWidth="400px">
                    <Modal.CloseButton />
                    <Modal.Header>{t('success')}</Modal.Header>
                    <Modal.Body>
                        {t('redeemSuccess')}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            variant={'ghost'}
                            onPress={() => {
                                props.onSuccessModalClose()
                            }}
                        >
                            {t('confirm')}
                        </Button>
                    </Modal.Footer>
                </Modal.Content>
            </Modal>
        </Box>
    )
}